import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import { ThumbUpAlt } from "@material-ui/icons";
import * as React from "react";
import { Confirm } from "react-admin";
export const AcceptIconButton = props => {
  const [open, setOpen] = React.useState(false);
  const handleClick = e => {
    e.stopPropagation();
    setOpen(true);
  };
  const handleDialogClose = () => {
    setOpen(false);
    props?.cancelOnClick?.(props?.record);
  };
  const handleConfirm = () => {
    props?.onClick?.(props?.record);
    setOpen(false);
  };
  return (
    <>
      <Tooltip TransitionComponent={Zoom} title={props.tooltip || "Confirm"}>
        <IconButton onClick={handleClick} style={{ color: "#12824C" }}>
          {props?.icon ? props.icon : <ThumbUpAlt />}
        </IconButton>
      </Tooltip>
      <Confirm
        isOpen={open}
        loading={props?.isLoading}
        title={props?.title ? props.title : ""}
        content={props?.content ? props?.content : "Do you approve of transaction?"}
        confirm="Yes"
        cancel="Cancel"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};
export default AcceptIconButton;
